import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const HealthMonitoring = () => {
    const { t } = useTranslation();
    const labelMappings = {
        0: { label1: t("patient_Details.right_eye"), label2: t("patient_Details.left_eye") },
        1: { label1: t("patient_Details.moderate_consumption") },
        2: { label1: t("patient_Details.smoking_status") },
        3: { label1: t("patient_Details.fasting_glucose") },
        4: {
            label1:
                t("patient_Details.hba1c"),
        },
        5: { label1: t("patient_Details.fasting_glucose") },
        6: { label1: t("patient_Details.pap_smear_result") },
        7: { label1: t("patient_Details.blood_pressure") },
    };

    const questionData = useSelector((state) => state.patient.getQuestionData?.data?.result || []);
    const answersData = useSelector((state) => state.patient.getAnswersData?.data?.result || []);

    const updatedQuestions = questionData.map((question, index) => {
        const filteredAnswers = answersData.filter(ans => ans.questionGuid === question.questionGuid);
        const updatedAnswers = filteredAnswers.map(answer => ({
            ...answer,
            ...labelMappings[index],
        }));

        return { ...question, answers: updatedAnswers };
    });

    return (
        <ul className="health-monitoring-ul">
            {updatedQuestions.map((que, index) => (
                <li key={index} className="health-monitoring-list">
                    <label className="exado-title-seven">{index + 1} : {que.question}</label>
                    {que.answers.length > 0 ? (
                        <div className="hm-ans-blk">
                            {que.answers.map((ans, ansIndex) => (
                                <div className="d-flex" key={`answer-${ansIndex}`}>
                                    <div className="exado-title-six w-25">
                                        {new Date(ans.createdDate).toLocaleDateString("en-US", {
                                            day: "numeric",
                                            month: "short",
                                            year: "numeric",
                                        })}{" "}
                                        {new Date(ans.createdDate).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </div>
                                    <div className="exado-title-six w-75">
                                        {ans.answer1} {ans.label1}
                                        {ans.answer2} {ans.label2}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p></p>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default HealthMonitoring;
